// export const BASE_URL = 'https://yr9i8czfkb.execute-api.ap-south-1.amazonaws.com/UAT';
// export const BASE_URL = 'http://localhost:5005';
export const BASE_URL = 'https://apiuat.healthmoni.com';